/* __next_internal_client_entry_do_not_use__ Accordion auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import * as React from "react";
import { Column, HorizontalLine } from "../Layout";
import { Spacer } from "../spacing";
import { Typography } from "../Typography";
import { AccordionListItem } from "./AccordionItem";
/**
 * [Figma](https://www.figma.com/file/s7VxgVsNoO1smpdecnUYoN/Foundation-Web-Master?node-id=5756%3A16949)
 * Faire Foundations standard UI for frequently asked questions
 *
 * @trackcomponent
 * @link [Docs](https://web-docs.faire.team/slate/Accordion)
 */ export var Accordion = function(param) {
    var items = param.items, onItemClick = param.onItemClick, _param_initiallyOpenIndex = param.initiallyOpenIndex, initiallyOpenIndex = _param_initiallyOpenIndex === void 0 ? -1 : _param_initiallyOpenIndex, _title = param.title, _param_titleAlignment = param.titleAlignment, titleAlignment = _param_titleAlignment === void 0 ? "center" : _param_titleAlignment, testId = param["data-test-id"], useSerif = param.useSerif;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var title = _title !== null && _title !== void 0 ? _title : strictLocalize({
        id: "1rmuse",
        defaultMessage: [
            {
                type: 0,
                value: "You may be wondering"
            }
        ]
    });
    var _React_useState = _sliced_to_array(React.useState(initiallyOpenIndex), 2), openIndex = _React_useState[0], setOpenIndex = _React_useState[1];
    var handleClick = function(index) {
        if (index === openIndex) {
            setOpenIndex(-1);
        } else {
            setOpenIndex(index);
        }
        onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(index);
    };
    return /*#__PURE__*/ _jsxs(Column, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: useSerif ? "sectionHeaderSansMedium" : "displaySSerifRegular",
                align: titleAlignment,
                "data-test-id": testId && "".concat(testId, "-title"),
                children: title
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            items.map(function(faqItem, index) {
                return /*#__PURE__*/ _jsxs(React.Fragment, {
                    children: [
                        index === 0 ? /*#__PURE__*/ _jsx(HorizontalLine, {}) : null,
                        /*#__PURE__*/ _jsx(AccordionListItem, _object_spread_props(_object_spread({}, faqItem), {
                            onClick: function() {
                                return handleClick(index);
                            },
                            isCollapsed: openIndex !== index,
                            "data-test-id": testId && "".concat(testId, "__item-").concat(index)
                        })),
                        /*#__PURE__*/ _jsx(HorizontalLine, {})
                    ]
                }, index);
            })
        ]
    });
};
Accordion.displayName = "Accordion";
